/**
 * 英文语言包：暂不维护，需要支持国际化时，按中文语言包格式复制后进行修改
 * 页面内静态文案全部放在此处，按业务模块拆分以防冲突
 */

import common from './modules/common';

export default {
    common,
};
